import { Box, Typography } from "@mui/material";
import { ActionButton, Flex, UserAvatar } from "@zfp-akademie-a-s/zfp-design";
import { EditIcon } from "@zfp-akademie-a-s/zfp-design/icons";
import { tileSx } from "Components/_Shared/Tile";
import type { AnalysisClientItemRelationType } from "Infrastructure/ApiZfp/Schema";
import { Spacing } from "Infrastructure/Themes/Themes";
import { Resources, useResource } from "Infrastructure/Translations/Resources";
import { format } from "date-fns";

type Props = {
  readonly clientId: string;
  readonly firstName: string;
  readonly lastName: string;
  readonly birthDate: string;
  readonly clientRelationType: AnalysisClientItemRelationType;
  readonly onEdit?: (clientId: string, clientRelationType: AnalysisClientItemRelationType) => void;
};

export const FamilyMember: React.FC<Props> = ({ clientId, firstName, lastName, birthDate, clientRelationType, onEdit }) => {
  const { t } = useResource();
  const fullName = `${firstName} ${lastName}`;

  return (
    <Flex
      justifyContent="space-between"
      alignItems="center"
      height={64}
      p={Spacing.XL}
      sx={[tileSx, { cursor: onEdit ? "pointer" : "default" }]}
      onClick={() => {
        onEdit?.(clientId, clientRelationType);
      }}
    >
      <Flex alignItems="center">
        <UserAvatar size="small" firstName={firstName} lastName={lastName} />
        <Flex flexDirection="column" ml={Spacing.L}>
          <Typography variant="caption" fontWeight={600}>
            {fullName}
          </Typography>
          <Typography variant="caption" color="secondary">
            {birthDate ? format(new Date(birthDate), "d. M. yyyy") : "-"}
          </Typography>
        </Flex>
      </Flex>
      {onEdit && <ActionButton label={t(Resources.Common.Edit)} icon={<EditIcon />} />}
    </Flex>
  );
};
